import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import moment from "moment";
import { validaSoloNumero } from "../../../util/varios";
import TablaReactivacion from "./tablaReactivacion";
import { Input } from "../../../ui/inputs/Input";

function Reactivacion(props) {
  const [enabled, setEnabled] = useState(true);
  const [factorCambio] = useState(0);
  const [facturas, setFacturas] = useState([]);
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const txtFecha = useRef();
  const txtNumAtencion = useRef();
  var op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  useEffect(() => {
    txtNumAtencion.current.value = "";
    txtFecha.current.value = "";
    setFacturas([]);
  }, [props.llamado]);

  const handleNumeroAtencion = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    setFacturas([]);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarRegistro();
      }
    }
  };

  const seleccionarNumAtencion = () => {
    let numaten = txtNumAtencion.current.value.trim();
    let fe = "'" + moment.utc(fechaSistema).format("YYYY-MM-DD") + "'";
    let llamado = "1";
    let endpoint = `${op.conexion}/api/Caja_Ingreso/seleccionarnumeroatencion?numaten=${numaten}&fecha=${fe}&idusuario=${idusuario}&llamado=${llamado}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let fact = [];
          for (let i = 0; i < response.data.length; i++) {
            fact.push({
              idfactura: response.data[i].idfactura,
              numfactura: response.data[i].numfactura,
              idcontribuyente: response.data[i].idcontribuyente,
              totalinmpuesto: response.data[i].totalinmpuesto,
              totalrecargo: response.data[i].totalrecargo,
              totalinteres: response.data[i].totalinteres,
              idtipoingreso: response.data[i].idtipoingreso,
              fechaemision: response.data[i].fechaemision,
              descripcion: response.data[i].descripcion,
              tablacontribuyente: response.data[i].tablacontribuyente,
              tabladeuda: response.data[i].tabladeuda,
              iddeuda: response.data[i].iddeuda,
              status: response.data[i].status,
              nombrecontri: response.data[i].nombrecontri,
              direccioncontri: response.data[i].direccioncontri,
              cedrif: response.data[i].cedrif,
              totalmulta:
                response.data[i].totalmulta === null
                  ? "0.00"
                  : response.data[i].totalmulta,
              deducible: response.data[i].deducible,
              facturador: response.data[i].facturador,
              totalfactura:
                parseFloat(response.data[i].totalinmpuesto) +
                parseFloat(response.data[i].totalrecargo) +
                parseFloat(response.data[i].totalinteres) +
                parseFloat(
                  response.data[i].totalmulta === null
                    ? "0.00"
                    : response.data[i].totalmulta
                ) -
                parseFloat(response.data[i].deducible),
              idcomercio: response.data[i].idcomercio,
              tipodeuda: response.data[i].tipodeuda,
            });
          }
          setFacturas(fact);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarRegistro = () => {
    let numaten = txtNumAtencion.current.value.trim();
    let campos = "*";
    let nomtab = "ordenatencion";
    let fe = "'" + moment.utc(fechaSistema).format("YYYY-MM-DD") + "'";
    let condi = `numaten = ${numaten} AND fecha = ${fe}`;

    let orden = "1";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            txtNumAtencion.current.value = response.data[0].numaten;
            setEnabled(false);
            txtFecha.current.value = moment.utc(response.data[0].fecha).format(
              "YYYY-MM-DD"
            );
            txtFecha.current.focus();
            setEnabled(true);
            seleccionarNumAtencion();
          } else {
            txtNumAtencion.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "El nùmero no existe.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const procesarNumeroAtencion = () => {
    setActivate(true);
    let body = {
      numaten: txtNumAtencion.current.value,
      fecha: fechaSistema,
      idusuario: idusuario,
      llamado: props.llamado,
    };

    let endpoint = `${op.conexion}/api/Caja_Ingreso/reactivarnumeroatencion`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Notificacion",
            texto:
              "El número de atención: " +
              (props.llamado === 1
                ? txtNumAtencion.current.value
                : response.data[0].ordenatencion_act) +
              " fué actualizado",
            icono: "informacion",
          });
          txtNumAtencion.current.value = "";
          txtFecha.current.value = "";
          setFacturas([]);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const cerrar = () => {
    props.menu();
  };

  return (
    <section
      className="col-12 m-0 p-0 d-flex align-items-center justify-content-center"
      style={{ height: "90dvh" }}
    >
      <div className="col-8 m-0 p-2 border rounded">
        <header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant rounded-top">
          <h3 class="m-0 fw-bold text-light">
            {props.llamado === 1
              ? "Reactivación de Número"
              : "Reasignación de Número"}
          </h3>
          <a type="button" onClick={cerrar} className="fw-bold text-light fs-6">
            Salir <i className="fa fa-times ms-2"></i>
          </a>
        </header>
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
          <div class="col-3 m-0 p-0">
            <Input label = 'N° de llamado:'
              ref={txtNumAtencion}
              onKeyUp={handleNumeroAtencion}
              onBlur={handleNumeroAtencion}
            />
          </div>
          <div class="col-2 m-0 p-0">
            <Input label = "Fecha:"
              disabled={enabled}
              ref={txtFecha}
            />
          </div>
        </div>
        <TablaReactivacion
          factorCambio={factorCambio}
          facturas={facturas}
          onHideRenderizar={seleccionarNumAtencion}
          onHideProcesar={procesarNumeroAtencion}
          llamado={props.llamado}
        />
      </div>
      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
    </section>
  );
}

export default Reactivacion;
